export const PAGE_ITEM_SELECTION = 'selection/PAGE_ITEM_SELECTION';
